import { ThemeOptions } from '@mui/material/styles';

export const acgColors = {
  primary: '#057ea3',
  primaryShade: '#0083a9',
  primaryTint: '#99bdc7',
  primaryContrast: '#ffffff',
  backgroundContent: '#ededed',
} as const;

const acgThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: acgColors.primary,
      dark: acgColors.primaryShade,
      light: acgColors.primaryTint,
      contrastText: acgColors.primaryContrast,
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderRadius: '16px',
          overflow: 'hidden',
          position: 'relative' as const,
          paddingBottom: '4px',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '4px',
            background: '#377d9f',
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: acgColors.primary,
          '&:focus': {
            color: acgColors.primaryShade,
            outline: `solid 2px ${acgColors.primaryShade}`,
          },
          '&:hover': {
            color: acgColors.primaryShade,
          },
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            backgroundColor: acgColors.primary,
            '&:focus': {
              border: `1px solid ${acgColors.primaryShade}`,
              backgroundColor: acgColors.primaryShade,
              outline: `solid 2px ${acgColors.primaryShade}`,
              outlineOffset: '1px',
            },
            '&:hover': {
              backgroundColor: acgColors.primaryShade,
            },
          },
        },
        {
          props: { variant: 'text' },
          style: {
            '&:focus': {
              color: acgColors.primaryShade,
              outline: `solid 2px ${acgColors.primaryShade}`,
              outlineOffset: '1px',
            },
          },
        },
      ],
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          '.MuiSwitch-switchBase.Mui-checked:hover': {
            backgroundColor: `${acgColors.primary}1A`,
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&:focus': {
            outline: `solid 2px ${acgColors.primaryShade}`,
          },
        },
      },
    },
  },
};

export default acgThemeOptions;
